import jQuery from 'jquery';
import Vue from 'vue';
import AccordionItem from '../vue/AccordionItem.vue';

(function ($) {

  /**
   * initializeBlock
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    15/4/19
   * @since   1.0.0
   *
   * @param  $block object The block jQuery element.
   * @param  attributes object The block attributes (only available when editing).
   * @return  void
   */
  const initializeBlock = function ($block) {
    // eslint-disable-next-line no-unused-vars
    const AccordionDownloads = new Vue({
      el: '#' + $block.attr('id'),
      components: {AccordionItem},
      data() {
        return {
          loading: false,
          items: [],
        };
      },
      methods: {
        accordionActivated: function (id) {
          console.log(id);
        },
      },
      mounted: function () {
        this.items = $block.data('items');
      },
    });
  };


  // Initialize each block on page load (front end).
  $(document).ready(function () {
    $('.block-downloads').each(function () {
      initializeBlock($(this));
    });
  });

  // Initialize dynamic block preview (editor).
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=block-downloads', initializeBlock);
  }

// eslint-disable-next-line no-undef
})(jQuery, wpApiSettings);
